// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles for Splash */

/* Splash and onboarding */
.splash {
  min-height: 100svh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
  color: white;
  background: var(--green-950);
}
.splash .brand {
  position: relative;
  z-index: 1;
}
.splash .brand-mark {
  background: white;
  color: var(--green-800);
}
.splash h1 {
  position: relative;
  font-size: clamp(3.2rem, 12vw, 7.5rem);
  line-height: 0.9;
  margin: 0.5rem 0 1.5rem;
}
.splash p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
}
.splash-orb {
  position: absolute;
  width: 500px;
  height: 500px;
  right: -220px;
  top: -180px;
  border-radius: 50%;
  background: var(--orange);
  filter: blur(1px);
  opacity: 0.8;
}
.splash-loader {
  width: 100%;
  height: 3px;
  overflow: hidden;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.15);
}
.splash-loader span {
  display: block;
  height: 100%;
  background: white;
  animation: load 1.3s ease forwards;
}
@keyframes load {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.onboarding {
  min-height: 100svh;
  display: grid;
  grid-template-rows: 48vh 1fr;
  background: var(--paper);
  position: relative;
}

.onboarding-image-juice {
  height: 513px !important;
}

.onboarding-copy-juice {
  padding: 9.5rem 1.5rem 2rem !important;
}

.onboarding-image {
  position: relative;
  margin: 1rem 1rem 0.5rem;
  overflow: hidden;
  border-radius: 1.5rem;
}
.onboarding-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.onboarding-image::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(transparent, rgba(18, 55, 42, 0.35));
}
.onboarding-icon {
  position: absolute;
  z-index: 1;
  left: 1.2rem;
  bottom: 1.2rem;
  width: 58px;
  height: 58px;
  display: grid;
  place-items: center;
  border-radius: 18px;
  color: var(--green-950);
  background: var(--yellow);
  font-size: 1.3rem;
}
.skip-link {
  position: absolute;
  z-index: 2;
  top: 2rem;
  right: 2rem;
  border: 0;
  border-radius: 50px;
  padding: 0.55rem 1rem;
  color: white;
  background: rgba(0, 0, 0, 0.35);
  font-weight: 700;
  backdrop-filter: blur(8px);
}
.onboarding-copy {
  padding: 1.5rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.onboarding-copy h1 {
  font-size: clamp(1.3rem, 8vw, 4rem);
  margin: 0.5rem 0 0.5rem;
}
.onboarding-copy p {
  color: var(--muted);
  font-size: 1.05rem;
  flex-grow: 1;
}
.dots {
  display: flex;
  gap: 0.35rem;
}
.dots span {
  width: 7px;
  height: 7px;
  border-radius: 99px;
  background: var(--line);
  transition: 0.2s;
}
.dots span.active {
  width: 28px;
  background: var(--green-700);
}

@media (min-width: 768px) {
  .onboarding {
    grid-template-columns: 1.1fr 0.9fr;
    grid-template-rows: 100svh;
  }
  .onboarding-image {
    margin: 1.5rem;
  }
  .onboarding-copy {
    padding: 4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Splash.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gEAAgE;AAClE;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Page-specific styles for Splash */\n\n/* Splash and onboarding */\n.splash {\n  min-height: 100svh;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  position: relative;\n  color: white;\n  background: var(--green-950);\n}\n.splash .brand {\n  position: relative;\n  z-index: 1;\n}\n.splash .brand-mark {\n  background: white;\n  color: var(--green-800);\n}\n.splash h1 {\n  position: relative;\n  font-size: clamp(3.2rem, 12vw, 7.5rem);\n  line-height: 0.9;\n  margin: 0.5rem 0 1.5rem;\n}\n.splash p {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1.1rem;\n}\n.splash-orb {\n  position: absolute;\n  width: 500px;\n  height: 500px;\n  right: -220px;\n  top: -180px;\n  border-radius: 50%;\n  background: var(--orange);\n  filter: blur(1px);\n  opacity: 0.8;\n}\n.splash-loader {\n  width: 100%;\n  height: 3px;\n  overflow: hidden;\n  border-radius: 3px;\n  background: rgba(255, 255, 255, 0.15);\n}\n.splash-loader span {\n  display: block;\n  height: 100%;\n  background: white;\n  animation: load 1.3s ease forwards;\n}\n@keyframes load {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n.onboarding {\n  min-height: 100svh;\n  display: grid;\n  grid-template-rows: 48vh 1fr;\n  background: var(--paper);\n  position: relative;\n}\n\n.onboarding-image-juice {\n  height: 513px !important;\n}\n\n.onboarding-copy-juice {\n  padding: 9.5rem 1.5rem 2rem !important;\n}\n\n.onboarding-image {\n  position: relative;\n  margin: 1rem 1rem 0.5rem;\n  overflow: hidden;\n  border-radius: 1.5rem;\n}\n.onboarding-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.onboarding-image::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(transparent, rgba(18, 55, 42, 0.35));\n}\n.onboarding-icon {\n  position: absolute;\n  z-index: 1;\n  left: 1.2rem;\n  bottom: 1.2rem;\n  width: 58px;\n  height: 58px;\n  display: grid;\n  place-items: center;\n  border-radius: 18px;\n  color: var(--green-950);\n  background: var(--yellow);\n  font-size: 1.3rem;\n}\n.skip-link {\n  position: absolute;\n  z-index: 2;\n  top: 2rem;\n  right: 2rem;\n  border: 0;\n  border-radius: 50px;\n  padding: 0.55rem 1rem;\n  color: white;\n  background: rgba(0, 0, 0, 0.35);\n  font-weight: 700;\n  backdrop-filter: blur(8px);\n}\n.onboarding-copy {\n  padding: 1.5rem 1.5rem 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.onboarding-copy h1 {\n  font-size: clamp(1.3rem, 8vw, 4rem);\n  margin: 0.5rem 0 0.5rem;\n}\n.onboarding-copy p {\n  color: var(--muted);\n  font-size: 1.05rem;\n  flex-grow: 1;\n}\n.dots {\n  display: flex;\n  gap: 0.35rem;\n}\n.dots span {\n  width: 7px;\n  height: 7px;\n  border-radius: 99px;\n  background: var(--line);\n  transition: 0.2s;\n}\n.dots span.active {\n  width: 28px;\n  background: var(--green-700);\n}\n\n@media (min-width: 768px) {\n  .onboarding {\n    grid-template-columns: 1.1fr 0.9fr;\n    grid-template-rows: 100svh;\n  }\n  .onboarding-image {\n    margin: 1.5rem;\n  }\n  .onboarding-copy {\n    padding: 4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
